<template>
  <el-button-icon
    :class="classP"
    icon="mdi-cancel"
    :disabled="disabled"
    :loading="loading"
  >
    <template v-if="isSlot">
      <slot></slot>
    </template>
    <template v-else>
      Anuliuoti
    </template></el-button-icon
  >
</template>

<script>
export default {
  name: 'ElButtonAnuliuoti',
  props: {
    classP: String,
    disabled: Boolean,
    loading: Boolean,
  },
  computed: {
    isSlot() {
      return !!this.$slots.default
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
